import { render, staticRenderFns } from "./MobileUploaderTip.vue?vue&type=template&id=46412587&scoped=true"
import script from "./MobileUploaderTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileUploaderTip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MobileUploaderTip.vue?vue&type=style&index=0&id=46412587&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46412587",
  null
  
)

export default component.exports